import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LayersTwo02 = function LayersTwo02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m7 12.0001-5 2.5 9.6422 4.8211c.1312.0656.1968.0984.2656.1113a.5.5 0 0 0 .1844 0c.0688-.0129.1344-.0457.2656-.1113L22 14.5001l-5-2.5m-15-2.5 9.6422-4.8211c.1312-.0656.1968-.0984.2656-.1113a.5.5 0 0 1 .1844 0c.0688.0129.1344.0457.2656.1113L22 9.5l-9.6422 4.8212c-.1312.0656-.1968.0984-.2656.1113a.5.5 0 0 1-.1844 0c-.0688-.0129-.1344-.0457-.2656-.1113z"
    })
  }));
};
export default LayersTwo02;